import { useClickOutside, useKey } from './../index';

const useDismissable = (ref, callback) => {
  useClickOutside(ref, callback);
  useKey('Escape', callback);
};

export default useDismissable;
